import { EmptyState, PageHeader } from '@wodi/ui';

import { useT } from '../i18n/i18n.tsx';

export function NotFoundPage() {
  const t = useT();
  return (
    <main style={{ padding: 'var(--space-5)' }}>
      <PageHeader title={t('error.notFoundTitle')} />
      <EmptyState action={<a href="/">{t('common.goHome')}</a>}>
        {t('error.notFoundBody')}
      </EmptyState>
    </main>
  );
}
